const GTM = require('../datalayer');
const gtmUtils = require('../utils');

const delay = ms => new Promise(res => setTimeout(res, ms));

const variationDataConditional = (variationID, allvarType, value) => {
    let selectedVariation = false;

    if ((variationID)) {
        if (allvarType[variationID].toString() === value.toString()) {
            selectedVariation = true;
        }
    }

    return selectedVariation;
};

const getVariationValues = (data, allvarType) => {
    const variationID = data.attributeId;

    return data.values.map(d => ({
        selected: variationDataConditional(variationID, allvarType, d.value),
        value: d.value,
    }));
};

// get current selected attr values
const getSelectedVariations = (variationData, product) => {
    const allSelectedvariationsType = {};
    const allAttrSelectors = product.find('.attribute > .attributeLink.isactive, .attribute > .swatchable > span.selected');

    allAttrSelectors.each((indx, val) => {
        const elem = $(val);
        allSelectedvariationsType[elem.parents('.swatch').data('attr')] = elem.data('attr-value');
    });

    const variationsArr = variationData.map(data => ({
        attributeId: data.attributeId,
        values: getVariationValues(data, allSelectedvariationsType),
    }));

    return gtmUtils.filterVariations(variationsArr);
};

const validateElement = element => (element === null ? '' : element);

const setCategoryListInfo = (categoryList, prodObj) => {
    const prodOBJ = prodObj;

    if (typeof categoryList === 'string') {
        prodOBJ.item_category = categoryList;
    } else {
        categoryList.forEach((val, index) => {
            if (index > 0) {
                prodOBJ[`item_category${index + 1}`] = `${val.id}_${val.displayValue}`;
            } else {
                prodOBJ.item_category = `${val.id}_${val.displayValue}`;
            }
        });
    }

    return prodOBJ;
};

const getDatalayerStructure = (element, item) => {
    const $categoryElem = element.find('.gtmProdCategory');
    const $gridFooter = $('.grid-footer');
    let prodObj = {
        item_name: element.find('.pdp-link > a')[0].innerText,
        item_id: validateElement(element.data('pid')).toString(),
        price: parseFloat(validateElement(element
            .find('.gtmProdPrice')
            .data('pinfo'))),
        item_brand: validateElement(element.find('.gtmProdBrand').data('pinfo')),
        item_list_name: gtmUtils.getList(element),
        discount: parseFloat(validateElement(element.find('.gtmProdDiscount').data('pinfo'))),
        quantity: 1,
        index: $('.grid-footer .paginator-label').length
            ? (parseInt($gridFooter.find('.paginator-label.active').attr('data-page'), 10) - 1) * parseInt($('.paginator-label.active').attr('data-sz'), 10) + item + 1
            : ($gridFooter.data('page-number') * $gridFooter.data('page-size')) + (item + 1),
    };

    if ($categoryElem.length) {
        prodObj = setCategoryListInfo($categoryElem.data('pinfo'), prodObj);
    }

    return prodObj;
};

const getAndPushCarouselImpressions = () => {
    const $product = $('.product');
    const $carousel = $('.featured-carousel-container, .product-carousel');

    if ($product.length) {
        delay(1000).then(() => {
            const allCarouselRef = $('.product-carousel');

            allCarouselRef.each((item, carouselValue) => {
                const $carouselValue = $(carouselValue);
                const $prodInCarousel = $carouselValue.find('.product');
                const products = [];

                if ($prodInCarousel.length) {
                    $prodInCarousel.each((prodItem, value) => {
                        const element = $(value);

                        if (element.find('.banner-product').length <= 0) {
                            products.push(getDatalayerStructure(element, prodItem));
                        }
                    });
                }

                GTM.trackProductImpression({
                    currency: $('.product').find('.price > span > meta').length
                        ? $('.product').find('.price > span > meta')[0].content
                        : $('.gtmCurrencyPrice').data('pinfo'),
                    product: products,
                });
            });
        });

        $carousel.off('DOMSubtreeModified');
    }

    if ($carousel.length && !$product.length) {
        $carousel.on('DOMSubtreeModified', () => {
            $('body').trigger('datalayer:updateCarousel');
        });
    }
};

const findProductsByPage = (prods) => {
    const selectedPage = $('.grid-footer');
    const pageSize = parseInt(selectedPage.attr('data-page-size'), 10);
    const pageNumber = parseInt(selectedPage.attr('data-page-number'), 10);

    return prods.slice(pageSize * pageNumber);
};

const getAndPushGridImpressions = () => {
    const typeViewOfGrid = $('#datalayerKindList').data('list');
    const products = [];
    const $paginator = $('.grid-footer .paginator-label');
    let $product = $('.product');

    if ((typeViewOfGrid === 'category' || typeViewOfGrid === 'search') && $product.length) {
        $product = !$paginator.length ? findProductsByPage($product) : $product;
        $product.each((item, value) => {
            const element = $(value);

            if (element.find('.banner-product').length <= 0) {
                products.push(getDatalayerStructure(element, item));
            }
        });

        GTM.trackProductImpression({
            currency: $('.product').find('.price > span > meta').length
                ? $('.product').find('.price > span > meta')[0].content
                : $('.gtmCurrencyPrice').data('pinfo'),
            product: products,
        });
    }


    if (typeViewOfGrid === 'search') {
        const searchInfo = $('#searchInfo').data('search');

        GTM.sendSearchResults(
            searchInfo,
        );
    }
};

const productQuickViewClicked = () => {
    const product = [];

    if ($('a.quickview').length) {
        $('body').on('click', 'a.quickview', (e) => {
            e.preventDefault();
            const productDiv = $($(e.currentTarget).parents('.product'));

            product.push(gtmUtils.productClickStructure(productDiv));

            GTM.trackQuickViewClickProduct('productQuickViewClick', {
                product,
                category: gtmUtils.getList(productDiv),
            });
        });
    }
};

const productClicked = () => {
    const product = [];

    if ($('.product-tile').length) {
        $('body').on(
            'click',
            '.product-tile > .image-container > a:not(.wishlistTile):not(.quickview), .product-tile > .tile-body > .pdp-link > a.product-name',
            (e) => {
                e.preventDefault();
                const productDiv = $($(e.currentTarget).parents('.product'));
                const productUrl = productDiv.find('.pdp-link > a')[0].href;

                let productInfo = gtmUtils.productClickStructure(productDiv);

                productInfo = setCategoryListInfo(productInfo.category, productInfo);
                delete productInfo.category;

                product.push(productInfo);


                GTM.trackClickedProduct(product, productUrl);

                window.location.href = productUrl;
            },
        );
    }
};

const getDatalaAddToCartStructure = (productToAdd) => {
    const gtmProdVariations = JSON.parse(productToAdd
        .find('.gtmProdVariations')
        .attr('data-pinfo'));
    const $categoryElem = productToAdd.find('.gtmProdCategory');

    let productStructure = {
        item_name: productToAdd.find('.pdp-link > a')[0].innerText,
        item_id: validateElement(productToAdd.data('pid')).toString(),
        price: parseFloat(validateElement(productToAdd
            .find('.gtmProdPrice')
            .data('pinfo')), 10),
        discount: parseFloat(validateElement(productToAdd.find('.gtmProdDiscount').data('pinfo'))),
        item_brand: validateElement(productToAdd.find('.gtmProdBrand').data('pinfo')),
        item_variant: gtmProdVariations.length
            ? getSelectedVariations(gtmProdVariations, productToAdd)
            : '',
        quantity: productToAdd.find('.quantity-form .quantity').val(),
        item_list_name: gtmUtils.getList(productToAdd),
    };

    if ($categoryElem.length) {
        productStructure = setCategoryListInfo($categoryElem.data('pinfo'), productStructure);
    }

    return productStructure;
};

const infoAddToCart = () => {
    $('body').on(
        'click',
        'button.add-to-cart-globalGrid',
        (e) => {
            const target = $(e.target);

            if (!target.hasClass('disabled')) {
                const productToAdd = target.parents('.product');
                GTM.trackAddProductToCart(
                    getDatalaAddToCartStructure(productToAdd),
                );
            }
        },
    );
};

const updateGridProductsData = () => $('body').on('datalayer:updateGrid', () => getAndPushGridImpressions());
const updateCarouselProductsData = () => $('body').on('datalayer:updateCarousel', () => getAndPushCarouselImpressions());

module.exports = {
    getAndPushGridImpressions,
    getAndPushCarouselImpressions,
    productQuickViewClicked,
    productClicked,
    infoAddToCart,
    updateGridProductsData,
    updateCarouselProductsData,
};
